import React, { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import TextField from "@material-ui/core/TextField";
import Modal from "react-bootstrap/Modal";
import { useAppDispatch, useAppSelector } from "../../useStore";
import { Spinners } from "../TableOptions";
import { UpdateEvaluatingStatus, reset, } from "../../features/Applicant/applicantSlice";
import swal from "sweetalert";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import ModalHeader from "../ModalHeader";

const EvaluationUpdateModal = ({ disabled, nametitle, name, id }: any) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const {
    UpdateEvaluatingStatusisError,
    UpdateEvaluatingStatusmessage,
    UpdateEvaluatingStatusisLoading,
    UpdateEvaluatingStatusisSuccess,
  } = useAppSelector((state: { applicant: any }) => state.applicant);

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);



  const [inputs, setInputs] = useState({
    comment: "",
    status: "COMPLETED",
    id: "",
  });

  useEffect(() => {
    if (UpdateEvaluatingStatusisError) {
      swal({
        title: "error",
        text: UpdateEvaluatingStatusmessage,
        icon: "error",
      });
    } else if (UpdateEvaluatingStatusisSuccess) {
      swal({
        title: "success",
        text: "Applicant Evaluation Completed!",
        icon: "success",
      });
      setShow(false);
      setInputs({
        comment: "",
        status: "COMPLETED",
        id: "",
      });
    }
    dispatch(reset());
  }, [UpdateEvaluatingStatusisError, UpdateEvaluatingStatusisSuccess, UpdateEvaluatingStatusmessage, dispatch, navigate]);

  const handleOnChange = (input: any, value: any) => {
    setInputs((prevState: any) => ({
      ...prevState,
      [input]: value,
    }));
  };

  useEffect(() => {
    setInputs((prevState: any) => {
      return {
        ...prevState,
        id: id,
      };
    });
  }, [inputs.id, setInputs, id]);

  const handleScreening = () => {
    // @ts-ignore
    dispatch(UpdateEvaluatingStatus(inputs));
  };

  return (
    <>
      <div
        onClick={() => {
          if (disabled) {
            toast.success("Evaluation has been Completed")
          } else {
            handleShow();
          }
        }}
        className="more-button"
      >
        <Button className={disabled ? "view-job-profile more-button-disabled" : "view-job-profile update"}>
          {disabled ? "Evaluation Completed" : "Update Evaluation Status"}
        </Button>
      </div>



      <Modal show={show} onHide={handleClose}>
        <ModalHeader setShow={setShow} headerTitle={"Update Evaluation Status"} />
        <Modal.Body>
          <form>
            <div className="applicant-name">
              <h5>Applicant Name</h5>
              <p>{nametitle + " " + name} </p>
            </div>
            <br />
            <div className="reviewer-name">
              <h6 className="mt-4">Update Evaluation Status</h6>
              <TextField
                id="outlined-basic"
                value="COMPLETED"
                variant="outlined"
                className="round"
                style={{ margin: "10px 0" }}
                fullWidth
                disabled
              />

              <div className="comment mt-4">
                <h6>Comment</h6>
                <TextField
                  id="outlined-multiline-static"
                  multiline
                  fullWidth
                  type="text"
                  minRows={4}
                  variant="outlined"
                  style={{ margin: "10px 0" }}
                  value={inputs.comment}
                  onChange={(e) => handleOnChange("comment", e.target.value)}
                />
              </div>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancel
          </Button>
          <Button id="primary" onClick={handleScreening}>
            {UpdateEvaluatingStatusisLoading ? <Spinners size={"sm"} /> : "Send"}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
export default EvaluationUpdateModal;
